







import $router from "@/router";
import store from "@/store";
import Vue from "vue";
import { FooterSettings } from "@/models";

const footerSettings: FooterSettings = {
  prevText: "page-privacy-tos.footer.prev",
  prevIcon: "fas fa-chevron-left",
  prevAction: function() {
    store.commit("setLoading", {
      loading: true,
      loadingText: "",
      transition: "slide-right"
    });
    $router.back();
  },
  prevVisible: true,
  prevEnabled: true,
  nextText: "",
  nextAction: undefined,
  nextVisible: false,
  nextEnabled: false
};

export default Vue.extend({
  name: "Privacy",
  mounted() {
    store.commit("changeFooter", footerSettings);
  }
});
